import { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import FormLabel from '../../components/form/FormLabel'
import { useDispatch, useSelector } from 'react-redux'
import { setLinksData, tryGenerateLinks } from '../../redux/slices/dashboardSlice'
import { localDateStringToIsoString } from '../../helpers/dateTimeHelper'

export const LinksJsonUploader = ({
                                   title,
                                   disabled = false,
                                   isRequired,
                                   setCustomLoading,
                                   className = 'w-full mb-4',
                                   formLabelTrailing,
                                 }) => {

  const dispatch = useDispatch()


  const _links = useSelector((state) => state.dashboard.links.data)


  useEffect(() => {
    if (_links) {
      downloadJSONFile(JSON.stringify({
        date_generated: localDateStringToIsoString(),
        products: _links,
      }, null, 2), _links.length)
      dispatch(setLinksData())
    }

  }, [_links])


  const { getRootProps, isDragActive } = useDropzone(
    {
      disabled: disabled,
      accept: '.json,application/json',
      maxFiles: 1,
      onDropAccepted: acceptedFiles => {
        readFileContents(acceptedFiles[0])
      },
      onDropRejected: (_) => {
        alert('Unsupported file type.')
      },
    })

  function readFileContents(file) {


    // console.log(file.type === 'application/json')

    if (file) {
      const reader = new FileReader()
      reader.onload = (event) => {
        const content = event.target.result
        dispatch(tryGenerateLinks(content))
      }
      reader.readAsText(file)
    }

  }

  async function onFileBrowsed(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!event.target.files.length) {
      return
    }
    readFileContents(event.target.files[0])
    event.target.value = ''

  }


  function downloadJSONFile(content, size = 0) {
    // 1. Create the Blob with the content and type
    const blob = new Blob([content], { type: 'application/json' })

    // 2. Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob)

    // 3. Create a hidden anchor element
    const link = document.createElement('a')
    link.href = url
    link.download = `links(${size})-${Date.now()}.json` // Set the default filename

    // 4. Append to body (required for Firefox), click, and remove
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // 5. Clean up the URL to save memory
    URL.revokeObjectURL(url)
  }

  return (
    <div className={className}>
      <FormLabel label={title ?? 'Upload File'} isRequired={isRequired} trailing={formLabelTrailing} />
      <label
        className={`${isDragActive && 'bg-gray-100 border-blue-500'} bg-secondary-100 relative border-2 border-rand-100  border-dashed rounded-md h-20 flex justify-center items-center overflow-hidden`} {...getRootProps()}>


        <div className="px-4 py-3 cursor-pointer">
          <input type="file" className="hidden" accept=".json,application/json" onChange={onFileBrowsed}
                 disabled={disabled} />
          <div className="flex items-center">
                    <span className="mr-2 text-5xl material-icons text-rand-300">
                    insert_photo
                    </span>
            <p className="text-sm font-medium text-rand-100">Drag and Drop Image or <span
              className="text-secondary-500">Click to Upload</span></p>
          </div>
        </div>

      </label>
    </div>

  )
}
